// extracted by mini-css-extract-plugin
module.exports = {"versionTable":"style-module_versionTable__1XwAe3WVTxAsn-AFQlaMcr"};